import { render, staticRenderFns } from "./AccountTeacherProfile.vue?vue&type=template&id=61c6388c&scoped=true&"
import script from "./AccountTeacherProfile.vue?vue&type=script&lang=js&"
export * from "./AccountTeacherProfile.vue?vue&type=script&lang=js&"
import style0 from "./AccountTeacherProfile.vue?vue&type=style&index=0&id=61c6388c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c6388c",
  null
  
)

export default component.exports